import React, { useEffect, useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { PublicClientApplication } from '@azure/msal-browser';
import { config, configdev, msalInstance } from '../config';
import './Login.css';
import axios from 'axios';
import { useCallback } from "react";

const Login = (props) => {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [username, setUsername] = useState('');
  const [organization, setOrganization] = useState("");
  const [loginSuccess, setLoginSuccess] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);

  const handleLoginViaUsername = (e) => {
    e.preventDefault();
    const validUsername = 'uagarwal@acuitas360.com';
    const validPassword = 'A360**';

    if (username === validUsername && password === validPassword) {
      setLoginSuccess(true);
      setErrorMessage('');
      setShowForgotPassword(false);
    } else {
      setErrorMessage('Invalid Credentials.');
    }
  };

  const handleBackToLogin = () => {
    setShowForgotPassword(false);
    setErrorMessage('');
  };

  useEffect(() => {
    navigate('/');
    const initializeMsal = async () => {
      try {
        await msalInstance.initialize();
        const accounts = msalInstance.getAllAccounts();

        if (accounts && accounts.length > 0) {
          setIsAuthenticated(true);
          setLoginSuccess(true);
          const accessTokenResponse = await msalInstance.acquireTokenSilent({
            scopes: ["User.Read"],
            account: accounts[0],
          });
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      } finally {
        setIsInitialized(true);
      }
    };

    initializeMsal();
  }, [navigate]);

  const handleLogin = async (event) => {
    event.preventDefault();

    if (!isInitialized) {
      console.warn('MSAL instance is not initialized yet');
      return;
    }

    try {
      const loginResponse = await msalInstance.loginPopup({
        scopes: ['user.read']
      });
      if (loginResponse) {
        setIsAuthenticated(true);
        setLoginSuccess(true);
        setShowForgotPassword(false);
      }
    } catch (error) {
      console.error("Login error:", error);
    }
    const currentDate = new Date(); 
    const seconds = currentDate.getSeconds();
    props.setLogin(`${String(seconds).padStart(2, '0')}`);
  };

  return (
    <div className="login-container">
      {/* Left Side - One Third */}
      <div className="login-left">
        <div className="login-left-content">
          <div className="logo-container">
            <img src="/images/onehumlogodark2.png" alt="ONEHUM" className="logo-image" />
          </div>
          <p className="platform-description">A One-Stop-Shop Commercial Operations Platform</p>
        </div>
        <div className="side-image-container">
          <img src="/images/sidemask.png" alt="Side Mask" className="side-image" />
        </div>
        <div className="copyright">
          <p>© 2025 Acuitas360. All rights reserved</p>
        </div>
      </div>

      {/* Right Side - Two Thirds */}
      <div className="login-right">
        <div className="login-form-container">
          {!loginSuccess && !showForgotPassword && <h2 className="login-heading">Login</h2>}
          
          {loginSuccess ? (
            <div className="login-success-container">
              <div className="success-content">
                <div className="success-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="#4CAF50" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                    <polyline points="22 4 12 14.01 9 11.01"></polyline>
                  </svg>
                </div>
                <h3 className="success-title">Login Successful!</h3>
                <p className="success-message">
                  You are being redirected to ONEHUM. If you are not redirected automatically, 
                  please contact your administrator.
                </p>
                <div className="loading-spinner">
                  <div className="spinner"></div>
                </div>
              </div>
            </div>
          ) : showForgotPassword ? (
            <div className="forgot-password-container">
              <h2 className="login-heading">Forgot Password</h2>
              <div className="forgot-password-message">
                <p>Please contact Acuitas360 administrator to reset your password.</p>
                <button 
                  className="back-to-login-button" 
                  onClick={handleBackToLogin}
                >
                  Back to Login
                </button>
              </div>
            </div>
          ) : (
            <form className="login-form">
              <div className="form-group">
                <label htmlFor="username" className="form-label">User name</label>
                <input 
                  type="text" 
                  id="username" 
                  placeholder="Enter Username" 
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="password" className="form-label">Password</label>
                <input 
                  type="password" 
                  id="password" 
                  placeholder="Enter Password" 
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <div className="forgot-password">
                  <a href="#" onClick={(e) => { e.preventDefault(); setShowForgotPassword(true); }}>
                    Forgot password?
                  </a>
                </div>
              </div>
              
              {errorMessage && <div className="error-message">{errorMessage}</div>}
              
              <button type="submit" className="login-button" onClick={handleLoginViaUsername}>Login</button>
              
              <div className="divider">
                <span>OR</span>
              </div>
              
              <button type="button" className="microsoft-button" onClick={handleLogin}>
                <svg className="ms-logo" width="16" height="16" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg">
                  <rect x="1" y="1" width="9" height="9" fill="#f25022"/>
                  <rect x="1" y="11" width="9" height="9" fill="#00a4ef"/>
                  <rect x="11" y="1" width="9" height="9" fill="#7fba00"/>
                  <rect x="11" y="11" width="9" height="9" fill="#ffb900"/>
                </svg>
                Sign in with Microsoft
              </button>
            </form>
          )}
          
          <div className="footer">
            <p className='text-base font-semibold text-gray-700'>Created by <a href="https://acuitas360.com/" className="footer-link" target="_blank">            
              <img src="/images/A360Logo2.png" alt="acuitas360 logo" className="h-10 inline-block" />
            </a></p>

            <div className="footer-links mt-2">
              <a href="https://www.acuitas360.com/privacy-page" className="footer-link" target="_blank">Privacy Policy</a>
              <span className="divider-line">|</span>
              <a href="https://www.acuitas360.com/privacy-page" className="footer-link" target="_blank">Terms of Use</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;